import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import '../Assets/Css/about.css';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import aboutbanner from '../Assets/Images/aboutbanner.avif';
import securityabout from '../Assets/Images/securityabout.avif';

import { FaCogs, FaDraftingCompass, FaTools, FaPuzzlePiece } from "react-icons/fa";
import { Helmet } from "react-helmet";

import img1 from "../Assets/Images/team1.jpg";
import img2 from "../Assets/Images/team2.jpg";
import img3 from "../Assets/Images/team10.jpg";
import img4 from "../Assets/Images/team12.jpg";
import img5 from "../Assets/Images/team16.jpg";
import img6 from "../Assets/Images/team3.jpg";
import img7 from "../Assets/Images/team5.jpg";
import img8 from "../Assets/Images/team7.jpg";
import img9 from "../Assets/Images/team15.jpg";
import img10 from "../Assets/Images/team8.jpg";
import img11 from "../Assets/Images/team23.jpg";
import img12 from "../Assets/Images/team6.jpg";
import img13 from "../Assets/Images/team18.jpg";
import img14 from "../Assets/Images/team4.jpg";
import img15 from "../Assets/Images/team9.jpg";


export default function About() {

  const images = [
    img1, img2, img12, img13, img3, img4, img5,
    img6, img7, img10,
    img11, img14, img15, img8, img9
  ];
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  };

  const highlightData = [
    {
      icon: <FaCogs size={40} className="icon icon-primary" />,
      title: 'Certified Company',
      description: 'PASARA, PF, ESIC, PT, Shop Act, and more'
    },
    {
      icon: <FaDraftingCompass size={40} className="icon icon-success" />,
      title: 'Professional Team',
      description: 'Experienced and government-compliant personnel'
    },
    {
      icon: <FaTools size={40} className="icon icon-danger" />,
      title: 'Customized Services',
      description: 'Tailored services at competitive rates'
    },
    {
      icon: <FaPuzzlePiece size={40} className="icon icon-warning" />,
      title: 'Trusted by Clients',
      description: 'Serving banks, hospitals, hotels & more'
    }
  ];

  return (
    <>
      

      <div className="mainnav">
      
    <Helmet>
      <title>About Us | Sumanik Security And Allied Services Pvt Ltd</title>
      <meta
        name="description"
        content="Learn about Sumanik Security, a certified and experienced private security company based in Pune, offering reliable security personnel, bouncers, and compliance-based services across India."
      />
      <meta
        name="keywords"
        content="About Sumanik Security, Security Company Pune, Certified Security Company, PASARA License, Trained Guards, Private Security India"
      />
      <meta name="author" content="Sumanik Security And Allied Services Pvt Ltd" />
      <meta property="og:title" content="About Us | Sumanik Security Pvt Ltd" />
      <meta
        property="og:description"
        content="Sumanik Security provides certified and customized security services across India with a team of trained and disciplined professionals."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.sumaniksecurity.com/about" />
      <meta property="og:image" content="https://www.sumaniksecurity.com/images/about-og.jpg" />
    </Helmet>

        {/* Banner Section */}
        <div className="about-banner position-relative text-white">
          <img
            src={aboutbanner}
            alt="About Banner"
            className="aboutbanner-image "
          />
          <div className="maindesc position-absolute translate-middle px-3 text-center">
            <h2 className="fw-bold">About -Sumanik Security and Allied Services Pvt Ltd</h2>
           
          </div>
        </div>

        {/* About Us Section */}
        <section className="aboutus-section py-4 bg-white">
          <Container>
            <h2 className="Mainhead mb-4">About Us</h2>
            <Row className="align-items-center">
              <Col lg={5} className="text-center mb-4">
                <div className='aboutimg'>
                  <img
                    src={securityabout}
                    alt="About Us"
                    className="img-fluid rounded shadow"
                    style={{ height: '250px', width: '100%' }}
                  />
                </div>
              </Col>
              <Col lg={7} className="mb-4">
                <p className="text-dark" style={{ textAlign: 'justify' }}>
                  We introduce ourselves as <b> Sumanik Security And Allied Services Pvt Ltd </b> located at Wanwadi, Pune City. We are a Private Limited company having all Government
                  Statutory Certificates i.e. PASARA License, PF, ESIC, PT, Shop and Est Act 1948 etc. All the legal liabilities and responsibilities shall be fulfilled as per the directions
                  and orders on the subject by Government and the client. Ours is a team of highly experienced, dedicated and professional trained security consultant and administrators.
                </p>
                <p className="text-dark" style={{ textAlign: 'justify' }}>
                  We provide a team of well-trained guarding force, dedicated bouncers and disciplined security personnel who can work under stressful situations
                  and can be completely relied upon. Owing to the customized availability and reasonable charges of our Security Services many banks, consulates,
                  shipping companies, security agencies, departmental stores, hospitals, airlines, jewelry manufacturers, clubs, hotels, government establishments,
                  etc., have bestowed their trust upon us.
                </p>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Company Highlights Section */}
        <section className="company-highlights-section mb-5">
  <Container>
    <h2 className="Mainhead mb-5 text-center">Why Choose Us?</h2>
    <div className="row">
      {highlightData.map((item, index) => (
        <div className="col-lg-3 col-md-6 col-12 mb-3" key={index}>
          <div className="highlight-col">
            {item.icon}
            <h5>{item.title}</h5>
            <p>{item.description}</p>
          </div>
        </div>
      ))}
    </div>
  </Container>
</section>


        {/* WhatsApp CTA */}
        <section className="cta-section mt-4 text-center py-5">
          <Container>
            <h4 className='mb-4'>
              Need Assistance or Have a Query?
            </h4>
            <a
              href="https://wa.me/917798737751"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-success mt-2"
            >
              Chat with us
            </a>
          </Container>
        </section>
      
        {/* Core Team Section */}
        <section className="team-section py-2 bg-light">
          <Container className='py-5 ' >
            <Row className='m-0'>
              <Col>
                <h2 className="Mainhead"> Meet Our Team
                </h2>
                <Slider {...settings}>
                  {images.map((img, index) => (
                    <div key={index}>
                      <img src={img} alt={`product-${index}`}
                        style={{ width: "100%", height: "auto", padding: "10px", borderRadius: '20px' }} />
                    </div>
                  ))}
                </Slider>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}
